<template>
  <div class="ScrollBox PageBox">
	  <van-nav-bar
	    fixed
	    :border="false"
	    :title="$t('userLc.default[0]')"
	    left-arrow
	    @click-left="$router.go(-1)">
	  </van-nav-bar>
	<div class="toptab">
		<span class="cur">{{this.taskTabs[0].text}}</span>
		<span @click="$router.push(`/user/newlist`)">{{this.taskTabs[1].text}}</span>
	</div>
	
	<div style="padding: 16px; background: #f8faf7; border-radius: 12px;">
	  <h3 style="font-weight: 700; 
	            font-size: 1.25rem;
	            color: #2A5C3D;
	            margin-bottom: 1rem;
	            letter-spacing: 0.5px;
	            text-shadow: 1px 1px 2px rgba(42,92,61,0.1);">
	    🚴 {{$t('newlist.title[0]')}}
	  </h3>
	  
	  <div style="line-height: 1.6; 
	            color: #4a6450;
	            font-size: 0.95rem;
	            border-left: 3px solid #C5B358;
	            padding-left: 1rem;">
	    <p style="margin-bottom: 1rem;width: 100%;">
	      🌱 {{$t('newlist.title[1]')}}
	    </p>
	    
	    <p style="width: 100%;">
	      🌍 {{$t('newlist.title[2]')}}
	    </p>
	  </div>
	</div>

		<ul class="ulC">
			<!-- <h4>{{$t("userLc.default[3]")}}</h4> -->
		  <!-- <li v-for="(item,index) in radioHeader" :key="index" @click="add(item)" :class="active == item.id ? 'active':''"> -->
		  <li 
		    v-for="(item,index) in radioHeader" 
		    :key="index" 
		    @click="open_product(item.id,item.rate)"
		    :style="{
		      background: `url(${item.imgurl}) no-repeat center/cover`,
		      position: 'relative',
		      overflow: 'hidden'
		    }"
		  >
		    
		    <div style="position: absolute;
		                top: 0;
		                left: 0;
		                right: 0;
		                bottom: 0;
		                background: rgba(0,0,0,0.1);
		                z-index: 1;">
		    </div>
		  
		    
		    <div class="list_box" style="position: relative; z-index: 2;">
		      
		      <div class="info" style="width: 50%;margin-left: 50%;margin-top: 5%;">
		        <span>{{item.title}}</span>
		        <div>{{$t("userLc.default[10]")}} {{item.lilv}}%</div>
		        <div>{{item.time}} {{$t("userLc.default[11]")}}</div>
		      </div>
		      <div v-if="item.rate==100">
		        <img style="position: absolute;left: 85%;top:58%;width: 50px;" 
		             :src="`./static/images/100.png`" />
		      </div>
		    </div>
		    <van-progress :percentage="item.rate" 
		                  stroke-width="8" 
		                  pivot-color="#d55048" 
		                  color="linear-gradient(90deg, #ff9ea5, #ff6257)"/>
		  </li>
		</ul>
    <!--公告-->
     <van-popup
        v-model="showNotice"
        v-if="InitData.invest && InitData.invest.length"
        style="background: transparent; width: 80%; text-align: center"
        @closed="showNotice = false"
      >
        <div
          class="NoticePopupL"
          v-if="InitData.invest && InitData.invest.length"
          @click="$router.push(`/article/invest/${InitData.invest[currentIndex].id}`)"
        >
          <h3 style="background-color: #971d35;color: #fff;">{{ InitData.invest[currentIndex].title }}</h3>
          <div class="txt">
            <!-- <div style="color: #999; text-align: center;font-size: 16px;">{{ InitData.noticelist[currentIndex].title }}</div> -->
            <div style="word-wrap:break-word;" v-html="InitData.invest[currentIndex].content"></div>
          </div>
        </div>
        <a class="close" href="javascript:;" @click="showNotice = false"
          ><van-icon name="clear" color="rgba(255,255,255,.8)" size="2.5rem"
        /></a>
      </van-popup>
  </div>
  
</template>

<script>
export default {
  name: 'newLc',
  components: {
  },
  props: [],
  data() {
    return {
      showHeader: false,
      showPassWord: false,
      showPayWord: false,
      radioHeader: [],
      postData: {},
      active:0,
      money:'',
      all:0.00,
      lv:0,
      flag:true,
	    taskTabs: [
        {state: 0, text: this.$t('userLc.tabs[0]')},
        {state: 1, text: this.$t('userLc.tabs[1]')},
      ],
      showNotice:false,
      currentIndex:0,
    }
  },
  computed: {
  },
  watch: {
      money(){
       return this.all = this.money * (this.lv/100)
      }
  },
  created() {
	  this.$Model.GetUserInfo();
    this.$parent.navBarTitle = this.$t("userLc.default[0]")
    //console.log(this.$parent)
	  this.$parent.rightText = ''
    this.list();
    if (this.InitData.invest.length) {
      this.showNotice = true;
    }
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {

  },
  methods: {
	rate(a) {
	  return a+'%';
	},
    sub(){
       if(this.money == '' || this.active == 0){
          this.$Dialog.Toast(this.$t("userLc.default[9]"));
          return
       }
       let obj = {
          userid:JSON.parse(localStorage.getItem("UserInfo")).userid,
          yuebaoid : this.active,
          money :this.money
       }
        this.$Model.newLcTj(obj,data=>{
            if(data.errorCode == 200){
              this.$Dialog.Toast(data.successMsg);
              this.active = 0
              this.flag = true
              this.money = ''
              this.$router.push(`/user/`)
              return
            }
            this.$Dialog.Toast(data.errorMsg);
        })
    },
    inputa(){ 
      if(this.active == 0){
        this.$Dialog.Toast(this.$t("userLc.default[8]"))
      }
    },
  //   add(item){
  //       this.flag = false
  //       this.active = item.id
  //       this.lv = item.lilv
		// this.all = this.money * (this.lv/100)
  //   },
	open_product(id,rate){
		if(rate<100)this.$router.push(`/user/product/${id}`);
	},
   list(){
	this.$Model.newLc({},data=>{
		this.radioHeader = data.info
	})
   }

  }
}
</script>
<style scoped>
.NoticePopupL {
    background-color: #fff;
    background-size: contain;
    height: 21.25rem;
    border-radius: 10px;
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
}
.NoticePopupL h3 {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    font-size: 1.25rem;
    font-weight: 600;
    color: #fff;
    line-height: 3.125rem;
}
.NoticePopupL .txt{border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 5px;
    color: #999;
    flex: auto;
    text-align: justify;}
.txt>>>img{max-width:100%}    
.amount{text-align: left;font-size: 0.75rem;color: rgb(136, 135, 154);line-height: 1.06rem;}
.money{text-align: left; color: #37774C; font-size: 1.88rem; padding-bottom: 0.5rem; font-weight: bold;}	
.bg{position: relative;padding-bottom: 1rem;}
.btn{background: linear-gradient(90deg, #37774C, #37774C);color: #fff;text-align: center;line-height: 50px;border-radius: 50px;width: 92%;margin: 30px auto 0 auto;}
input::-webkit-input-placeholder{color:#999999;font-weight: normal;font-size: 14px;}
input::-moz-placeholder{   /* Mozilla Firefox 19+ */color:#999999;font-weight: normal; font-size: 14px}
input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */color:#999999; font-weight: normal;font-size: 14px;}
input:-ms-input-placeholder{  /* Internet Explorer 10-11 */  color:#999999; font-weight: normal; font-size: 14px;}
.three{padding: 1.19rem 1rem;display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-pack: center;-ms-flex-pack: center;justify-content: center;}
.ulC{display: -webkit-box;display: -ms-flexbox;display: flex;-webkit-box-pack: justify;-ms-flex-pack: justify;justify-content: space-between;-webkit-box-align: center;-ms-flex-align: center;align-items: center;-ms-flex-wrap: wrap;flex-wrap: wrap;padding: 0 1.06rem;color: #333;}
.ulC h4{width: 100%;padding-bottom: 1rem;}
/* .three,.ulC{background: #fff;border-radius: 1rem;-webkit-box-shadow: 0 1px 2px rgb(0 0 0 / 20%);box-shadow: 0 1px 2px rgb(0 0 0 / 20%);} */
.three i{font-size: 1rem;}
.three input{border: 0;text-align: right;flex: 1 1 0%;background: transparent;}
.three span{color: #37774C;font-weight: normal;line-height: 2.26rem;    margin-left: 5px;}
.one{padding:0 10px ;}
.PageBox{position: relative;color: #333;background-color:#fafafa !important}
.PageBox h5{text-align: center;padding: 10px 0;color: #969696;position: relative;}
.two{border-radius: 1rem;font-size: 16px;font-weight: 700;margin: 10px;color: rgb(51, 51, 51);}
.PageBox h5 span{width: 100%;position: absolute;left:0;top: 50%;height: 1px;background: #eeeeee;z-index: -1;}
.PageBox h5 i{background: #fff;width: 30%;display: inline-block;}
.PageBox p{display: flex;align-items: center;background: #f3f4f6;width:45%;border-radius: 5px; padding: 15px;justify-content: center;}
.PageBox p img{width: 30px;height: 30px;margin-right: 5px;}
.ulC .list_box{
    height: 110px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

	}
.ulC li{
    /* height: 150px; */
    cursor: pointer;
    margin-bottom: 16px;
    background: #37774C;
    border-radius: 8px;
    padding: 0 8px;
	width: 100%;
	color: #FFFFFF;
	padding: 10px;
	}
.van-progress{
	margin: 10px 0;
}
.ulC li.active{border: 2px solid #ffbcbd;border-radius: 8px;padding: 6px;width: 100%; box-sizing: border-box;color: #ffbcbd;}
.ulC li span{display: block;width: 100%;font-size: 0.8rem;}
.ulC li .info{
	width: 100%;
	font-size: 0.875rem;
	position: relative;
	padding-left: 0.625rem;
	line-height: 29px;
	font-weight: 500;
	}
.ulC li i{font-size: .6rem;display: block;text-align: center;}
.ulC::after{content: '';width: 30%;}
.toptab {
    background: #fff;
    border: 1px solid #37774C;
    height: 35px;
    line-height: 35px;
    display: flex;
    text-align: center;
    border-radius: 8px;
    overflow: hidden;
	margin: 10px 20px;
}
.toptab span {
    flex: 1;
    font-weight: 500;
    font-size: 14px;
    position: relative;
    color: #37774C;
    cursor: pointer;
}
.toptab span.cur {
    background: #37774C;
    color: #fff;
}

.ulC li {
  /* 移除原有背景�*/
  background-blend-mode: multiply; /* 混合模式增强可读�*/
  transition: all 0.3s ease; /* 添加悬停动画 */
}

.ulC li:hover {
  transform: scale(0.98);
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}
</style>